import { render, staticRenderFns } from "./profile-edit.vue?vue&type=template&id=c39fbff0&scoped=true"
import script from "./profile-edit.vue?vue&type=script&lang=js"
export * from "./profile-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39fbff0",
  null
  
)

export default component.exports